<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :value="cursoProgramado.Subcategoria.subcategoria"
          rounded
          filled
          dense
          background-color="primary"
          color="secondary"
          label="Curso"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-select
          label="Capacitadores"
          background-color="primary"
          color="secondary"
          rounded
          filled
          dense
          item-value="id"
          item-text="nombre"
          v-model="cursoProgramado.fkidCapacitador"
          :items="capacitadores"
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-select
          label="Aula"
          background-color="primary"
          color="secondary"
          rounded
          filled
          dense
          item-value="id"
          item-text="aula"
          v-model="cursoProgramado.fkidAula"
          :items="aulas"
        ></v-select>
      </v-col>
      <v-col v-if="periodoCurso" cols="12">
        <v-date-picker v-model="periodoCurso" locale="es" color="secondary" no-title full-width range></v-date-picker>
      </v-col>
      <v-col cols="6">
        <v-text-field :value="cursoProgramado.fechaInicio" label="Fecha inicio" readonly></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field :value="cursoProgramado.fechaFin" label="Fecha fin" readonly></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      aula: null,
      nombre: null,
      sugcategoria: null,
      periodoCurso: null,
    }
  },

  mounted() {
    this.periodoCurso = [
      moment(this.cursoProgramado.fechaInicio, this.API_DATE_FORMAT).format(this.VUETIFY_DATE_FORMAT) || null,
      moment(this.cursoProgramado.fechaFin, this.API_DATE_FORMAT).format(this.VUETIFY_DATE_FORMAT) || null,
    ]
  },

  computed: {
    ...mapGetters('cursoProgramado', {
      cursoProgramado: 'getSelectedCursoProgramado',
    }),
    ...mapGetters('aula', {
      aulas: 'getAulas',
    }),
    ...mapGetters('capacitador', {
      capacitadores: 'getCapacitadores',
    }),
    ...mapGetters('curso', {
      cursoToUpdate: 'getCursoToUpdate',
    }),
    ...mapGetters('curso', {
      cursos: 'getCursos',
    }),
    getMaxDay: function() {
      return moment().format(this.VUETIFY_DATE_FORMAT)
    },
  },
}
</script>
